import { Button, TextField, Typography } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { makeStyles } from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Box } from '../../UI';
import './custom.css';

function Login({ history }) {
	const classes = useStyles();
	const [values, setValues] = React.useState({
		email: '',
		password: 'aXcessDemo2020',
		showPassword: false,
	});
	const [error, setError] = React.useState('');

	const handleChange = prop => event => {
		setValues({ ...values, [prop]: event.target.value });
	};
	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};
	const handleMouseDownPassword = event => {
		event.preventDefault();
	};

	const validateForm = () => {
		let isValid = false;
		if (values.password === 'aXcessDemo2020') isValid = true;
		return isValid;
	};

	const encode = data => {
		const formData = new FormData();
		Object.keys(data).forEach(k => {
			formData.append(k, data[k]);
		});
		return formData;
	};

	const handleSubmit = e => {
		e.preventDefault();
		const data = { 'form-name': 'axcess', email: values.email };

		if (validateForm()) {
			fetch('/', {
				method: 'POST',
				body: encode(data),
			})
				.then(() => history.push('/market-search'))
				.catch(error => setError('Submission failed'));
		} else {
			setError('Incorrect password');
		}
	};

	React.useEffect(() => {
		localStorage.setItem('terms', 'false');
	}, []);

	return (
		<Box>
			<form
				className={classes.form}
				data-netlify="true"
				hidden
				name="axcess"
				netlify-honeypot="bot-field"
				onSubmit={handleSubmit}
			>
				<input name="bot-field" type="hidden" />
				<TextField
					label="Email"
					variant="outlined"
					className={classes.input}
					value={values.email}
					onChange={handleChange('email')}
					type="email"
					name="email"
				/>
				<FormControl className={classes.input} variant="outlined">
					<InputLabel htmlFor="password">Password</InputLabel>
					<OutlinedInput
						id="password"
						type={values.showPassword ? 'text' : 'password'}
						name="password"
						value={values.password}
						onChange={handleChange('password')}
						endAdornment={
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									onMouseDown={handleMouseDownPassword}
									edge="end"
								>
									{values.showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>
						}
						labelWidth={70}
					/>
				</FormControl>
				<Button className={classes.button} variant="contained" color="primary" type="submit">
					Login
				</Button>
			</form>
			{error && (
				<Typography variant="body1" style={{ color: '#ff7f41', marginTop: '1rem' }}>
					{error}
				</Typography>
			)}
		</Box>
	);
}

export default withRouter(Login);

const useStyles = makeStyles(theme => ({
	form: {
		zIndex: 2,
		display: 'flex',
		flexDirection: 'column',
		paddingTop: theme.spacing(4),
	},
	input: {
		background: '#4D4D4D',
		'& input, & label, & svg': {
			color: '#9D9D9D !important',
		},
		marginBottom: theme.spacing(3),
	},
	button: {
		marginTop: theme.spacing(2),
	},
}));
